import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import style from './Spinner.module.scss'

// Tesco's loader: a brand-blue ring with a clear centre, centred in the block it stands in for.
const Spinner = () => {
  const { t } = useSurveyLocale()

  return (
    <div className={style.box} role="status" aria-label={t('questions', 'ec', 'loading')} data-testid="SW-EC-Spinner">
      <span className={style.ring} />
    </div>
  )
}

export default Spinner
